module.exports = __webpack_public_path__ + "img/6.8b4d1eb0.png";